var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptoReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2245_206)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.9883,
    r: 40,
    fill: "#3094B4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2853 52.0723L58.2934 47.0339V25.8446C58.2934 24.8196 57.4651 23.9883 56.4438 23.9883H23.6132C22.592 23.9883 21.7645 24.8196 21.7645 25.8446V47.0339L17.7719 52.0723C17.6674 52.2037 17.6113 52.3663 17.6113 52.5351V54.7651C17.6113 55.5835 18.2715 56.246 19.0861 56.246H60.9711C61.7856 56.246 62.4465 55.5835 62.4465 54.7651V52.5351C62.4465 52.3663 62.3897 52.2037 62.2853 52.0723ZM24.3733 26.6075H55.6838V44.4148H24.3733V26.6075ZM44.2426 54.4848H35.8152V52.2456H44.2426V54.4848Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2785 39.1777H29.1777V42.2899H32.2785V39.1777Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9289 36.0664H33.8281V42.2909H36.9289V36.0664Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5774 34.5098H38.4766V42.2904H41.5774V34.5098Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2278 29.8418H43.127V42.2908H46.2278V29.8418Z",
    fill: "#F9F9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.886 32.9531H47.7852V42.2898H50.886V32.9531Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2245_206",
    x: 0,
    y: 0.988281,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113333 0 0 0 0 0.432533 0 0 0 0 0.533333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2245_206"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoReports);
export default __webpack_public_path__ + "static/media/crypto-reports.984b86eaa9ebff7f62ec86f0bcb6d723.svg";
export { ForwardRef as ReactComponent };